"use client";

import { HorizontalCategoricalBar } from "@/components/charts/HorizontalCategoricalBar";
import { getPalette, type PaletteToken } from "@/lib/palette";
import { usePrefersDark } from "@/lib/usePrefersDark";

export type SectorRow = {
  sector: string;
  share_of_total: number;
};

type Props = {
  data: SectorRow[];
};

const SECTOR_TOKENS: Record<string, PaletteToken> = {
  Residential: "teal",
  ICI: "cyan",
  "Regional customers": "violet",
  "Municipal operations": "slate",
  "Non-revenue water": "brick",
};

export function SectorBarChart({ data }: Props) {
  const p = getPalette(usePrefersDark());
  const rows = data.map((r) => ({
    label: r.sector,
    value: r.share_of_total,
    color: p[SECTOR_TOKENS[r.sector] ?? "teal"],
  }));

  return (
    <HorizontalCategoricalBar
      data={rows}
      height={320}
      valueDomain={[0, 0.5]}
      xTickFormatter={(v) => `${(v * 100).toFixed(0)}%`}
      valueLabelFormatter={(v) => `${(v * 100).toFixed(1)}%`}
      tooltipLabel="Share of total"
      tooltipValueFormatter={(v) => `${(v * 100).toFixed(1)}%`}
      categoryWidth={140}
    />
  );
}
